const VVVO_IDENTIFIER_REGEX = /^vvvo-\d{12}$/;

export const isValidVVVOIdentifier = (str: string) => VVVO_IDENTIFIER_REGEX.test(str.toLowerCase());

export const truncateString = (text: string, length: number) => {
  if (text.length > length) {
    return `${text.substr(0, length).split(" ").slice(0, -1).join(" ")}...`;
  }
  return text;
};

export const gentlyTruncateString = (text: string, length: number) => {
  if (text.length > length) {
    return `${text.substr(0, length).split(" ").join(" ")}...`;
  }
  return text;
};

export const stripHtml = (text: string) => (typeof text === "string" ? text.replace(/<[^>]*>?/gm, "") : text);

// camelize kebabs ("i-am-a-kebab" => "iAmAKebab")
export const camelize = (s: string) => s.replace(/-./g, (x) => x[1].toUpperCase());

// camelize strings ("I am a string" => "iAmAString")
export const camelizeString = (s: string) => s.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (_, c) => c.toUpperCase());

export const reverseCamelizeString = (string: string) =>
  string
    .replace(/([A-Z])/g, " $1")
    .toLowerCase()
    .trim();
